<template>
  <div>

    <q-list v-if="fieldValue && fieldValue.locations && fieldValue.locations.length > 1" bordered padding class="rounded-borders q-mb-md">
      <template v-for="(place, place_index) in fieldValue.locations"
                :key="place_index">
      <q-item clickable v-ripple  v-if="fieldValue.locations[place_index].valid" active-class="bg-teal-1 text-grey-8" :active="place_index === index">
        <q-item-section avatar top>
          <q-avatar icon="s_place" color="grey" text-color="white" />
        </q-item-section>

        <q-item-section @click="selectLocation(place_index)">
          <q-item-label lines="1">{{fieldValue.locations[place_index].address}} {{fieldValue.locations[place_index].unit}}</q-item-label>
          <q-item-label caption>{{fieldValue.locations[place_index].city}}, {{fieldValue.locations[place_index].state}}, {{fieldValue.locations[place_index].zip}}, {{fieldValue.locations[place_index].type}}, {{fieldValue.locations[place_index].own_type}},
            <span v-if="fieldValue.locations[place_index].years">{{fieldValue.locations[place_index].years}} years, </span><span v-if="fieldValue.locations[place_index].months"> {{fieldValue.locations[place_index].months}} months</span></q-item-label>
        </q-item-section>

        <q-item-section side @click.stop="confirmDeleteAlert(place_index)">
          <q-icon name="s_delete" color="amber"  />
        </q-item-section>
      </q-item>
      </template>
    </q-list>
    <div class="text-body2">Please make sure the address details are correct</div>
    <template v-if="index !== null && fieldValue.locations[index] !== undefined">
      <q-form
          @submit="onSubmit"
          ref="form"
      >
      <div class="full-width">
        <div class="row">
          <div class="col-md-12 q-mb-sm">
      <q-field
          borderless
          v-model="fieldValue.locations[index].type"
          :rules="[ val => val && val.length > 0 || 'Please select residence type']"
          :hide-bottom-space="true"
      >
        <template v-slot:control>
          <q-option-group
              :options="this.types"
              type="radio"
              v-model="fieldValue.locations[index].type"
              debounce="500"
          />
        </template>
      </q-field>
          </div>
        </div>

      <div class="row q-pb-md">
        <div class="col-12 col-md-8 q-px-sm">
          <FieldAddress
              v-model="fieldValue.locations[index].address"
              :field="{layout_injected_label: 'Address', label: 'Address', required: true, requiredText: null, options: {}}"
              @onAddressSelected="onAddressSelected"
              :doNotCheckStateLicense="true"
          ></FieldAddress>
        </div>
        <div class="col-12 col-md-4 q-px-sm">
          <FieldText
              v-model="fieldValue.locations[index].unit"
              :field="{layout_injected_label: 'Unit', label: 'Unit', required: false, requiredText: null, options: {}}"
          ></FieldText>
        </div>
      </div>
        <div class="row q-pb-md">
          <div class="col-12 col-md-4 q-px-sm">
            <FieldText
                v-model="fieldValue.locations[index].city"
                :field="{layout_injected_label: 'City', label: 'City', required: true, requiredText: null, options: {}}"
            ></FieldText>
          </div>
          <div class="col-12 col-md-4 q-px-sm">
            <FieldState
                v-model="fieldValue.locations[index].state"
                :field="{layout_injected_label: 'State', label: 'State', required: true, requiredText: null, options: {}}"
            ></FieldState>
          </div>
          <div class="col-12 col-md-4 q-px-sm">
            <FieldZipcode
                v-model="fieldValue.locations[index].zip"
                :field="{layout_injected_label: 'Zip', label: 'Zip', required: true, requiredText: null, options: {}}"
            ></FieldZipcode>
          </div>
        </div>
        <div class="row q-pb-md">
          <div class="col-12 col-md-4 q-px-sm">
            <FieldSelect
                v-if="location_years_more_less_then_10"
                v-model="fieldValue.locations[index].years"
                :field="{layout_injected_label: 'Years at address', label: 'Years at address', required: true, requiredText: null,
                options: {
                  0: 'Less than a year',
                  1: '1 Years',
                  2: '2 Years',
                  3: '3 Years',
                  4: '4 Years',
                  5: '5 Years',
                  6: '6 Years',
                  7: '7 Years',
                  8: '8 Years',
                  9: '9 Years',
                  10: '10 Years',
                  999: '> 10 Years'
                }
                }"
            ></FieldSelect>
            <FieldNumber
                :ref="'address_location_years_' + index"
                v-if="!location_years_more_less_then_10"
                v-model="fieldValue.locations[index].years"
                :field="{layout_injected_label: 'Years at address', label: 'Years at address', required: true, requiredText: null, options: {}}"
            ></FieldNumber>
          </div>
          <div class="col-12 col-md-4 q-px-sm">
            <FieldSelect
                v-model="fieldValue.locations[index].months"
                :field="{layout_injected_label: 'Months at address', label: 'Months at address', required: false, requiredText: null,
                 options: {
                  0: 'Less than a month',
                  1: '1 Months',
                  2: '2 Months',
                  3: '3 Months',
                  4: '4 Months',
                  5: '5 Months',
                  6: '6 Months',
                  7: '7 Months',
                  8: '8 Months',
                  9: '9 Months',
                  10: '10 Months',
                  11: '11 Months',
                  12: '12 Months'
                }
                }"
            ></FieldSelect>
          </div>
          <div class="col-12 col-md-4 q-px-sm">
            <FieldSelect
                v-model="fieldValue.locations[index].own_type"
                :field="{layout_injected_label: 'Rent or Own', label: 'Rent or Own', required: true, requiredText: null,
                options: fieldValue.locations[index].type === 'Current' ? {
                  'Rent': 'I rent this property',
                  'Own': 'I own this property',
                  'Rent free': 'I live here Rent free'
                } : {
                  'Rent' : 'I rent this property',
                  'Own': 'I own this property',
                  'Owned': 'I no longer own this property'
                }
                }"
            ></FieldSelect>
          </div>
        </div>



        <div class="row">
          <div class="col-12 q-py-sm q-ml-none col-md-12 q-gutter-sm">


            <q-btn
                v-if="fieldValue.locations.length > 1"
                class="mw-form-v2-btn-submit "
                :flat="!settings.theme.next.cs ? settings.theme.button.flat: null"
                :rounded="!settings.theme.next.cs ? settings.theme.button.rounded: null"
                :round="!settings.theme.next.cs ? settings.theme.button.round: null"

                :outline="true"
                :push="!settings.theme.next.cs ? settings.theme.button.push: null"
                :unelevated="!settings.theme.next.cs ? settings.theme.button.unelevated: true"
                :noCaps="!settings.theme.next.cs ? settings.theme.button.noCaps: null"
                :glossy="!settings.theme.next.cs ? settings.theme.button.glossy : null"
                :size="settings.theme.next.cs ? settings.theme.next.size : settings.theme.button.size"

                label="Remove this address" type="button" color="primary"
                :class="{'mw-form-v2-btn-next-cs':  settings.theme.next.cs}"
                @click="confirmDeleteAlert(index)"
            >
            </q-btn>

            <q-btn

                class="mw-form-v2-btn-submit "
                :flat="!settings.theme.next.cs ? settings.theme.button.flat: null"
                :rounded="!settings.theme.next.cs ? settings.theme.button.rounded: null"
                :round="!settings.theme.next.cs ? settings.theme.button.round: null"

                :outline="true"
                :push="!settings.theme.next.cs ? settings.theme.button.push: null"
                :unelevated="!settings.theme.next.cs ? settings.theme.button.unelevated: true"
                :noCaps="!settings.theme.next.cs ? settings.theme.button.noCaps: null"
                :glossy="!settings.theme.next.cs ? settings.theme.button.glossy : null"
                :size="settings.theme.next.cs ? settings.theme.next.size : settings.theme.button.size"

                label="Add Another Address" type="submit" color="primary"
                :class="{'mw-form-v2-btn-next-cs':  settings.theme.next.cs}"
            >
            </q-btn>


          </div>
        </div>
      </div>
      </q-form>
    </template>
    <div class="text-body2 q-mt-sm">Must Enter at least 2 years of housing for all borrowers</div>
    <q-field class="field_no_bottom_line" :hide-bottom-space="true"   :rules="[val => isValid() || '2 years of residence is required']">
    </q-field>

    <q-dialog v-model="confirm" persistent>
      <q-card>
        <q-card-section class="row items-center">
          <q-avatar icon="s_place" color="primary" text-color="white" />
          <span class="q-ml-sm">Switch to this address will clear a current item.</span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn flat label="Confirm" @click="clearCurrentAndSwitch()" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog v-model="confirmDelete" persistent>
      <q-card>
        <q-card-section class="row items-center">
          <q-avatar icon="s_place" color="primary" text-color="white" />
          <span class="q-ml-sm">Are you sure to delete this address {{fieldValue.locations[confirmDeleteIndex] && fieldValue.locations[confirmDeleteIndex].address}}?</span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn flat label="Delete" @click="deleteItem()" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import {mapFields} from "vuex-map-fields";
import FieldAddress from "@/components/fields/FieldAddress";
import FieldText from "@/components/fields/FieldText";
import FieldState from "@/components/fields/FieldState";
import FieldZipcode from "@/components/fields/FieldZipcode";
import FieldSelect from "@/components/fields/FieldSelect";
import FieldNumber from "@/components/fields/FieldNumber";
import {mapActions} from "vuex";
export default {
  components: {
    FieldNumber,
    FieldAddress,
    FieldText,
    FieldState,
    FieldZipcode,
    FieldSelect
  },
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {
        confirm: false,
        confirmIndex: null,
        confirmIndexToClear: null,
        confirmDelete: false,
        confirmDeleteIndex: null,
        location_years_more_less_then_10: true,
        types:[
          { label: 'This is my current residence', value: 'Current' },
          { label: 'This is a previous residence', value: 'Previous'}
        ],
        location: {
          type: "",
          address: "",
          unit: "",
          city: "",
          state: "",
          zip: "",
          country: "",
          years: "",
          months: "",
          own_type: ""
        },
        locations:[

        ],
        index: null
    };
  },
  emits: ['update:modelValue'],
  methods: {
    ...mapActions({
      updateFieldValueByFieldType: 'values/list/updateFieldValueByFieldType'
    }),
    isValidLocation(index) {
      const location = this.fieldValue.locations[index];
      return !(!location.address
          || !location.type
          || !location.city
          || !location.state
          || !location.zip
          || location.years === ""
          || location.years === null
          );

    },
    isValid () {
      let yearsCount = 0;
      let own_indicator = 'No';
      for (let i in this.fieldValue.locations) {
        if(this.fieldValue.locations[i].years) {
          yearsCount = yearsCount + parseInt(this.fieldValue.locations[i].years);
        }
        if(this.fieldValue.locations[i].months) {
          yearsCount = yearsCount + parseInt(this.fieldValue.locations[i].months) / 12;
        }
        if(this.fieldValue.locations[i].own_type === 'Own') {
          own_indicator = 'Yes';
        }
      }
      this.$refs.form.validate().then((success) => {
        this.fieldValue.locations[this.index].valid = success;
      });

      let result = this.isValidLocation(this.index) && yearsCount >= 2;

      if(result) {
        this.updateFieldValueByFieldType({form: this.form_entity, type: 'borrower.real_estate_own.has_one_or_more_indicator', fieldValue: own_indicator});
      }

      return result;
    },
    onSubmit() {
      this.fieldValue.locations[this.index].valid = true;
      this.index = this.fieldValue.locations.push(Object.assign({id: this.generateId()}, this.location)) - 1;
      this.$refs.form.reset();
    },
    onAddressSelected(location) {
      this.fieldValue.locations[this.index].city = location.city;
      this.fieldValue.locations[this.index].state = location.state;
      this.fieldValue.locations[this.index].zip = location.zipcode;
    },
    selectLocation(place_index) {
      //this.$refs.form.resetValidation();
      this.confirmIndex = place_index;
      this.confirmIndexToClear = this.index;
      this.$refs.form.validate().then(success => {
        if (success) {
          this.index = place_index;
        }
        else {
          this.confirm = true;
        }
      });
    },
    clearCurrentAndSwitch() {
      this.$refs.form.reset();
      this.index = this.confirmIndex;
      this.fieldValue.locations.splice(this.confirmIndexToClear, 1);
    },
    confirmDeleteAlert(index) {
      console.log(this.fieldValue.locations);
      this.confirmDeleteIndex = index;
      this.confirmDelete = true;

    },
    deleteItem() {
      if(this.fieldValue.locations.length === 1) {
        this.fieldValue.locations.push(Object.assign({id: this.generateId()}, this.location));
      }
      this.fieldValue.locations.splice(this.confirmDeleteIndex, 1);
      this.index = this.fieldValue.locations.length -1;
    },
    generateId() {
      return new Date().getTime() + '_' + Math.random();
    },
    processYearLogic(value) {
      console.log('processYearLogic');
      if(this.location_years_more_less_then_10 && value.locations[this.index] !== undefined) {
        if(value.locations[this.index].years === "999") {
          value.locations[this.index].years = "";
          this.location_years_more_less_then_10 = false;
          this.$nextTick(() => {
            //console.log(this.$refs['address_location_years_' + this.index]);
            this.$refs['address_location_years_' + this.index].focus()
          })
        }
      }
    }
  },
  watch: {
    fieldValue: {
      handler(val){
        this.processYearLogic(val)
      },
      deep: true
    }
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings',
      form_entity: 'form'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please select';
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {

        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {
      if(this.fieldValue === undefined || this.fieldValue === null) {
        this.fieldValue = {
          locations: [
            Object.assign({id: this.generateId()}, this.location)
          ]
        };
      }
      this.index = 0;
  }
}
</script>
<style>
.field_no_bottom_line .q-field__control:before {
  border-bottom-color: transparent !IMPORTANT;
}
.field_no_bottom_line  .q-field__control:after {
  background: none !important;
}
.field_no_bottom_line .q-field__control {
  display: none;
}
</style>
